import axios from 'axios';

export function getDidacticTypes(params) {
  return axios.get('cms/didactic-types', { params });
}
